var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// ./~/victory-polar-axis/~/lodash/_nativeKeys.js
// module id = ./node_modules/victory-polar-axis/node_modules/lodash/_nativeKeys.js
// module chunks = 1